import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmDossierVO {
  id?: number
  caseId: number
  category: string
  title: string
  fileUrl: string
  fileName?: string
  versionNo?: number
  isCurrent?: boolean
  rootFileId?: number
  caseTitle?: string
  firmCaseNo?: string
}

export interface FirmDossierPageReq extends PageParam {
  caseId?: number
  category?: string
  currentOnly?: boolean
}

export const FirmDossierApi = {
  create: (data: FirmDossierVO) => request.post({ url: '/lawyer/firm/dossier/create', data }),
  update: (data: FirmDossierVO) => request.put({ url: '/lawyer/firm/dossier/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/dossier/delete?id=' + id }),
  page: (params: FirmDossierPageReq) =>
    request.get<PageResult<FirmDossierVO>>({ url: '/lawyer/firm/dossier/page', params }),
  newVersion: (data: { id: number; fileUrl: string; fileName?: string }) =>
    request.post({ url: '/lawyer/firm/dossier/new-version', data }),
  versions: (rootFileId: number) =>
    request.get<FirmDossierVO[]>({ url: '/lawyer/firm/dossier/versions?rootFileId=' + rootFileId })
}

export interface FirmAlertSummaryVO {
  todayHearingCount: number
  upcomingDeadlineCount: number
  overdueTaskCount: number
  overdueDeadlineCount: number
  expiringContractCount: number
}

export interface FirmAlertItemVO {
  alertType: string
  refId: number
  caseId?: number
  caseTitle?: string
  title: string
  dueDate?: string
  status?: string
}

export const FirmAlertApi = {
  summary: () => request.get<FirmAlertSummaryVO>({ url: '/lawyer/firm/alert/summary' }),
  list: (limit = 20) => request.get<FirmAlertItemVO[]>({ url: '/lawyer/firm/alert/list', params: { limit } })
}
